// vehicles
export const GET_VEHICLES_SUCCESS = 'GET_VEHICLES_SUCCESS';
export const GET_VEHICLES_FAILURE = 'GET_VEHICLES_FAILURE';
export const GET_VEHICLES_REQUEST = 'GET_VEHICLES_REQUEST';
export const CLEAR_VEHICLES = 'CLEAR_VEHICLES';

// pagination
export const SET_VEHICLES_SEARCH = 'SET_VEHICLES_SEARCH';
export const SET_VEHICLES_PAGE_SIZE = 'SET_VEHICLES_PAGE_SIZE';
export const NEXT_VEHICLES_PAGE = 'NEXT_VEHICLES_PAGE';
export const PREV_VEHICLES_PAGE = 'PREV_VEHICLES_PAGE';
